<template>
    <div class="auth-form__agreement">
        <label class="auth-form__agreement-label" :for="name">
            <input
                :id="name"
                class="auth-form__checkbox"
                type="checkbox"
                :name="name"
                :value="modelValue"
                @input="updateValue($event.target.checked)"
            >
            <span class="auth-form__agreement-text">
                <strong v-if="required" class="auth-form__agreement-required">*</strong>
                {{ label }}
            </span>
        </label>
        <ul class="form-field__error" v-if="errors">
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['label', 'type', 'name', 'require', 'errorMessages', 'modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('input', value === true ? 1 : 0);
            if (this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },
    },
    data() {
        return {
            value: '',
            required: this.require,
        };
    },
    computed: {
        errors: function () {
            if (this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        },
    },
    watch: {
        errorMessages: function () {
            this.value = '';
        },
    },
};
</script>
